import SideBar from "./SideBar";
import TopnavBar from "./TopBar";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col sm:flex-row">
      {/* Sidebar for larger screens */}
      <div className="hidden sm:block w-[16em] h-screen sticky top-0 overflow-y-auto">
        <SideBar />
      </div>

      {/* Top Navbar for smaller screens */}
      <div className="block sm:hidden w-full">
        <TopnavBar />
      </div>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto bg-white">
        {children}
      </main>
    </div>
  );
};

export default Layout;
